export const sportsDataHistoryRequiredQuery = {
  bool: {
    must: [
      { exists: { field: 'sportsData.stat' } },
      { nested: { path: 'sportsData.history', query: { exists: { field: 'sportsData.history' } } } },
    ],
  },
};
